import React, { FC } from "react";
import { ErrorBoundary } from "react-error-boundary";

const fallbackRender = ({ error }: { error: any }) => {
  return (
    <div role="alert">
      <p>Something went wrong:</p>
      <pre style={{ color: "red" }}>{error.message}</pre>
    </div>
  );
};

const StandardErrorBoundary = (props: any) => (
  <ErrorBoundary FallbackComponent={fallbackRender}>
    {props.children}
  </ErrorBoundary>
);

export default StandardErrorBoundary;
